import React, { useEffect, useState, useRef } from "react";
import {
  Tabs,
  Row,
  Col,
  Tag,
  DatePicker,
  Select,
  Button,
  Switch,
  Input,
  Tooltip,
  Table,
  notification,
  Pagination,
  Modal,
  Form,
  Collapse,
  Space,
  Typography,
  message,
} from "antd";
import {
  DownloadOutlined,
  LoadingOutlined,
  SearchOutlined,
  CommentOutlined,
  ClockCircleOutlined,
  FormOutlined,
  UserOutlined,
  PhoneOutlined,
  PlusOutlined,
  LinkOutlined,
  SyncOutlined,
  DeleteOutlined,
  CopyOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import "./binhluan.scss";
import $axios from "../../services/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import dayjs from "dayjs";
import SendMessage from "./SendMessage";
import useDebounce from "../../hooks/useDebounceValue";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;
const { Panel } = Collapse;
const { Paragraph, Text } = Typography;

const DateFormat = "DD-MM-YYYY";

// Sample App Script code for the example
const EXAMPLE_SCRIPT = `function doGet(e) {
  return ContentService.createTextOutput(JSON.stringify({
    status: "active",
    message: "API is working correctly",
    version: "1.0",
    timestamp: new Date().toISOString()
  })).setMimeType(ContentService.MimeType.JSON);
}

function formatHeaders(sheet, numColumns) {
  const headerRange = sheet.getRange(1, 1, 1, numColumns);
  headerRange.setBackground('#ff7731');
  headerRange.setFontColor('white');
  headerRange.setFontWeight('bold');
  headerRange.setBorder(true, true, true, true, true, true);
  sheet.autoResizeColumns(1, numColumns);
  sheet.setRowHeight(1, 30);
  sheet.setFrozenRows(1);
}

function doPost(e) {
  try {
    const params = e.parameter || {};
    const values = [];
    const columnHeaders = [];
    
    let i = 0;
    while (params[\`field\${i}\`] !== undefined) {
      values.push(params[\`field\${i}\`]);
      columnHeaders.push(params[\`header\${i}\`] || \`Field \${i + 1}\`);
      i++;
    }
    
    if (values.length === 0) {
      return ContentService.createTextOutput(JSON.stringify({
        success: false,
        message: "No data to add"
      })).setMimeType(ContentService.MimeType.JSON);
    }
    
    const ss = SpreadsheetApp.getActiveSpreadsheet();
    const sheet = ss.getActiveSheet();
    
    if (params.sheetName && sheet.getName() !== params.sheetName) {
      sheet.setName(params.sheetName);
    }
    
    const lastRow = sheet.getLastRow();
    
    if (lastRow === 0) {
      const headerRow = [];
      
      if (params.includeTimestamp === 'true') {
        headerRow.push('Timestamp');
      }
      
      headerRow.push(...columnHeaders);
      sheet.appendRow(headerRow);
      formatHeaders(sheet, headerRow.length);
    }
    
    if (params.includeTimestamp === 'true') {
      values.unshift(new Date().toISOString());
    }
    
    sheet.appendRow(values);
    
    const newDataRow = sheet.getLastRow();
    const numColumns = sheet.getLastColumn();
    sheet.getRange(newDataRow, 1, 1, numColumns).setVerticalAlignment("middle");
    
    return ContentService.createTextOutput(JSON.stringify({
      success: true,
      message: "Data added successfully",
      sheetName: sheet.getName(),
      data: values
    })).setMimeType(ContentService.MimeType.JSON);
    
  } catch (error) {
    return ContentService.createTextOutput(JSON.stringify({
      success: false,
      message: "Error: " + error.message
    })).setMimeType(ContentService.MimeType.JSON);
  }
}`;

const Binhluan = () => {
  const [showModalSendMessage, setShowModalSendMessage] = useState(false);
  const [showAppScriptModal, setShowAppScriptModal] = useState(false);
  const [appScriptId, setAppScriptId] = useState("");
  const [submittingAppScript, setSubmittingAppScript] = useState(false);
  const [syncingSheet, setSyncingSheet] = useState(false);
  const [hasAppScript, setHasAppScript] = useState(false);
  const [copyStatus, setCopyStatus] = useState(false);
  const [form] = Form.useForm();

  function getDayBeforeNDays(n) {
    const day = new Date();
    day.setDate(day.getDate() - n);
    return moment(day).format(DateFormat);
  }
  const [filter, setFilter] = useState({
    fromTime: getDayBeforeNDays(10),
    toTime: getDayBeforeNDays(0),
    offset: 0,
    limit: 20,
    onlyPhone: false,
  });
  const [totalPost, setTotalPost] = useState(0);
  const [recordSelected, setRecordSelected] = useState({
    id: "",
  });
  const [search, setSearch] = useState("");
  const [list_comment, setListComment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [loadingButton, setLoadingButton] = useState([]);
  const [pager, setPager] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const debouncedSearchValue = useDebounce(search, 500);
  const [expandedRows, setExpandedRows] = useState([]);

  const toggleRow = (index) => {
    const newExpandedRows = [...expandedRows];
    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };

  const tableRowClassName = (record, index) => {
    // Implement your logic for row class name
    return "";
  };

  const GetStatusInvite = (row) => {
    // Implement your logic for getting status invite
    return "";
  };

  useEffect(() => {
    getComments();
  }, [filter, pager, pageSize, debouncedSearchValue]);

  // Kiểm tra và lấy thông tin App Script khi component mount
  useEffect(() => {
    getUserAppScript();
  }, []);

  const getComments = async () => {
    try {
      setLoading(true);
      const result = await $axios.get(
        `comment/list?fromTime=${convertStringToDate(
          filter.fromTime,
        )}&toTime=${convertStringToDate(
          filter.toTime,
        )}&search=${debouncedSearchValue}&page=${pager}&perPage=${pageSize}&onlyPhone=${
          filter.onlyPhone
        }`,
      );
      setLoading(false);
      let data = result.data.data;
      setTotalPost(result.data._metadata.pagination.total);
      setListComment(data);
    } catch (error) {
      setLoading(false);
      notification.error({
        message: "Thất bại",
        description: "Lấy dữ liệu thất bại",
      });
    }
  };

  function convertStringToDate(inputString) {
    const momentObj = moment(inputString, "DD-MM-YYYY");
    momentObj.add(1, "day");
    const formattedString = momentObj.toISOString();
    return formattedString ?? "";
  }

  const checkPhone = async (record, index) => {
    try {
      const loadingButton2 = [...loadingButton];
      loadingButton2[index] = true;
      setLoadingButton(loadingButton2);
      const result = await $axios.get(`comment/check-phone/${record._id}`);
      const data = result.data.data;
      if ((data || []).length) {
        if (!data[0].name) {
          notification.error({
            message: "Không tìm thấy",
            description: "Zalo không hiển thị",
          });
        } else {
          const newData = list_comment.map((comment) =>
            comment._id === record._id
              ? {
                  ...comment,
                  facebook: {
                    zalos: data,
                  },
                }
              : comment,
          );
          setListComment(newData);
        }
      } else {
        notification.error({
          message: "Không tìm thấy",
          description: "Không quét ra được infozalo",
        });
      }
    } catch (error) {
      notification.error({
        message: "Không tìm thấy",
        description: "Vui lòng thêm tài khoản zalo",
      });
    } finally {
      const loadingButton2 = [...loadingButton];
      loadingButton2[index] = false;
      setLoadingButton(loadingButton2);
    }
  };

  const onShowSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };

  const columns = [
    {
      title: (
        <div>
          <ClockCircleOutlined />
          <span className="font-500 ms-1">Thời gian</span>
        </div>
      ),
      dataIndex: "time",
      key: "time",
      align: "center",
      fixed: false,
      with: "10%",
      render: (text, record) => (
        <>
          {record.status_friend_id === 10 ? (
            <LoadingOutlined />
          ) : (
            <Tag
              className="cursor-pointer text-primary border-primary bg-white text-14 py-1"
              type={GetStatusInvite(record)}
              closable={false}
              effect="plain"
            >
              {moment(record.time).format("HH:mm:ss DD/MM/YYYY")}
            </Tag>
          )}
        </>
      ),
    },
    {
      title: (
        <div>
          <FormOutlined />
          <span className="font-500 ms-1">Tên bài</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      align: "center",
      fixed: false,
      with: "5%",
      render: (text, record) => (
        <>
          <a
            className="text-decoration-none text-label cursor-pointer"
            href={`${record.post.url}`}
            target="_blank"
          >
            {record.post?.name || ""}
          </a>
        </>
      ),
    },
    {
      title: "FB Name",
      dataIndex: "fb",
      key: "fb",
      align: "center",
      fixed: false,
      with: "5%",
      render: (text, record) => (
        <>
          <Tooltip title={record.uid}>
            <a
              className="text-decoration-none text-14"
              href={`https://www.facebook.com/${record.uid}`}
              target="_blank"
            >
              <FontAwesomeIcon
                icon={faUser}
                style={{ color: "#409EFF" }}
                className="text-12"
              />
              <span className="ms-1">{record.name}</span>
            </a>
          </Tooltip>
        </>
      ),
    },
    {
      title: (
        <div>
          <PhoneOutlined />
          <span className="font-500 ms-1">SĐT</span>
        </div>
      ),
      dataIndex: "facebook",
      key: "facebook",
      align: "center",
      fixed: false,
      with: "5%",
      render: (text, record, index) => (
        <>
          {record?.facebook?.zalos?.length ? (
            <>
              {record.facebook.zalos.map((data, index) => {
                return (
                  <div key={index}>
                    <Button
                      onClick={(e) =>
                        data.name
                          ? handleShowModal(record)
                          : checkPhone(record, index)
                      }
                      className={`${
                        data.name
                          ? "bg-blue text-white border-blue"
                          : "text-white bg-danger border-danger"
                      } text-white text-12`}
                      size="small"
                    >
                      {data.name
                        ? `${data?.phone} (${data?.name})`
                        : data?.phone}
                    </Button>
                    <br />
                  </div>
                );
              })}
            </>
          ) : null}
        </>
      ),
    },
    {
      title: (
        <div>
          <CommentOutlined />
          <span className="font-500 ms-1">Bình luận</span>
        </div>
      ),
      dataIndex: "comment",
      key: "comment",
      align: "center",
      fixed: false,
      with: "5%",
      render: (text, record, index) => (
        <>
          {record.message.length > 40 ? (
            <>
              {expandedRows[index] ? (
                <>
                  <span>{record.message + "  "}</span>
                  <a
                    className="text-blue text-decoration-none"
                    onClick={() => toggleRow(index)}
                  >
                    Ẩn bớt
                  </a>
                </>
              ) : (
                <>
                  {record.message.slice(0, 40) + "..."}
                  <a
                    className="text-blue text-decoration-none"
                    onClick={() => toggleRow(index)}
                  >
                    Xem thêm
                  </a>
                </>
              )}
            </>
          ) : (
            record.message
          )}
        </>
      ),
    },
  ];

  const handleShowModal = (record) => {
    setRecordSelected(record);
    setShowModalSendMessage(true);
  };

  const onCancel = () => {
    setShowModalSendMessage(false);
  };

  const exportData = async () => {
    setLoadingExport(true);
    try {
      const response = await $axios.get(
        `/comment/export?fromTime=${convertStringToDate(
          filter.fromTime,
        )}&toTime=${convertStringToDate(filter.toTime)}`,
        {
          responseType: "arraybuffer",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const nameFile = "CommentsExport.xlsx";
      a.download = nameFile;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      notification.error({
        message: "Thất bại",
        description: "Có lỗi xảy ra",
      });
    } finally {
      setLoadingExport(false);
    }
  };

  // Hàm xử lý hiển thị modal thêm App Script
  const showAddAppScriptModal = () => {
    setShowAppScriptModal(true);
  };

  // Hàm xử lý đóng modal thêm App Script
  const handleAppScriptCancel = () => {
    setShowAppScriptModal(false);
    form.resetFields();
  };

  const getUserAppScript = async () => {
    try {
      const response = await $axios.get("/user/profile");

      if (
        response.data &&
        response.data.data &&
        response.data.data.appScriptId
      ) {
        setHasAppScript(true);
        setAppScriptId(response.data.data.appScriptId);
      } else {
        setHasAppScript(false);
      }
    } catch (error) {
      console.error("Lỗi khi lấy thông tin App Script:", error);
    }
  };

  // Hàm gọi API thêm App Script
  const submitAppScriptLink = async () => {
    try {
      setSubmittingAppScript(true);
      const values = await form.validateFields();

      const response = await $axios.patch("/user/app-script", {
        appScriptUrl: values.scriptUrl,
      });

      notification.success({
        message: "Thành công",
        description: "Thêm App Script thành công",
      });

      setHasAppScript(true);
      setAppScriptId(values.scriptUrl);

      setShowAppScriptModal(false);
      form.resetFields();
    } catch (error) {
      notification.error({
        message: "Thất bại",
        description:
          error.response?.data?.message || "Có lỗi xảy ra khi thêm App Script",
      });
    } finally {
      setSubmittingAppScript(false);
    }
  };
  const deleteAppScript = async () => {
    try {
      await $axios.delete("/user/app-script");

      notification.success({
        message: "Thành công",
        description: "Xóa App Script thành công",
      });

      setHasAppScript(false);
      setAppScriptId("");
    } catch (error) {
      notification.error({
        message: "Thất bại",
        description:
          error.response?.data?.message || "Có lỗi xảy ra khi xóa App Script",
      });
    }
  };

  const syncSheet = async () => {
    try {
      setSyncingSheet(true);
      const postIds = [
        ...new Set(
          list_comment
            .map((comment) => comment.post?.postId)
            .filter((postId) => postId),
        ),
      ];
      if (postIds.length === 0) {
        notification.info({
          message: "Thông báo",
          description: "Không có bài viết nào để đồng bộ",
        });
        setSyncingSheet(false);
        return;
      }

      const response = await $axios.post(
        "/comment/push-comments-by-posts",
        {
          postIds: postIds,
          appScriptId: appScriptId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("accessToken")
              ?.replace(/"/g, "")}`,
          },
        },
      );

      notification.success({
        message: "Thành công",
        description: `Đồng bộ ${postIds.length} bài viết lên Sheet thành công`,
      });

      getComments();
    } catch (error) {
      notification.error({
        message: "Thất bại",
        description:
          error.response?.data?.message || "Có lỗi xảy ra khi đồng bộ Sheet",
      });
    } finally {
      setSyncingSheet(false);
    }
  };

  // Copy function for example script
  const copyScript = () => {
    navigator.clipboard.writeText(EXAMPLE_SCRIPT).then(
      () => {
        setCopyStatus(true);
        message.success("Đã sao chép mã script vào clipboard");
        setTimeout(() => setCopyStatus(false), 3000);
      },
      () => {
        message.error("Không thể sao chép mã script");
      },
    );
  };

  return (
    <div className="binhluan card">
      <Tabs type="card">
        <TabPane
          tab={
            <span>
              <CommentOutlined />
              Bình luận
            </span>
          }
        >
          <div className="content px-3 pb-3">
            <Row gutter={20}>
              <Col span={14} offset={0} className="d-flex">
                <Tag
                  className="text-14 border-primary bg-white text-primary py-1 h-100"
                  closable={false}
                  effect="plain"
                >
                  {totalPost} bình luận
                </Tag>
                <RangePicker
                  className="h-100"
                  onChange={(dates, dateString) => {
                    setFilter({
                      ...filter,
                      fromTime: dateString[0],
                      toTime: dateString[1],
                    });
                  }}
                  separator="To"
                  format={DateFormat}
                  defaultValue={[
                    dayjs(filter.fromTime, DateFormat),
                    dayjs(filter.toTime, DateFormat),
                  ]}
                  placeholder={["Từ ngày", "Đến ngày"]}
                />
              </Col>
              <Col span={10} offset={0}>
                <Row className="align-items-center">
                  <Col span={7} offset={5}>
                    <Switch
                      onChange={(e) => setFilter({ ...filter, onlyPhone: e })}
                      style={{ marginRight: "10px" }}
                    />
                    <span className="text-14">Chỉ hiển thị SĐT</span>
                  </Col>
                  <Col span={12}>
                    <Input
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Tìm kiếm từ khóa ..."
                      prefix={<SearchOutlined />}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="mt-4">
              {/* Nút App Script góc phải */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "10px",
                  gap: "10px",
                }}
              >
                {hasAppScript ? (
                  <>
                    <Button
                      type="primary"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={deleteAppScript}
                    >
                      Xóa App Script
                    </Button>
                  </>
                ) : (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={showAddAppScriptModal}
                  >
                    Thêm App Script Sheet
                  </Button>
                )}
              </div>

              <Table
                size="small"
                dataSource={list_comment}
                loading={loading}
                scroll={{
                  x: "max-content",
                  y: `calc(100vh - 350px)`,
                }}
                rowClassName={tableRowClassName}
                bordered
                pagination={false}
              >
                {columns.map((column) => (
                  <Table.Column
                    key={column.key}
                    title={column.title}
                    dataIndex={column.dataIndex}
                    align={column.align}
                    width={column.width}
                    fixed={column.fixed}
                    render={column.render}
                    sorter={column.sorter}
                  />
                ))}
              </Table>
              <Pagination
                className="mt-3"
                current={pager}
                total={totalPost}
                onChange={(page) => setPager(page)}
                pageSize={pageSize}
                showSizeChanger
                onShowSizeChange={onShowSizeChange}
              />
              <SendMessage
                props={{
                  sendMessageShow: showModalSendMessage,
                  onClose: onCancel,
                  record: recordSelected,
                }}
              />

              {/* Redesigned App Script Modal */}
              <Modal
                title="Thêm App Script Sheet"
                visible={showAppScriptModal}
                onCancel={handleAppScriptCancel}
                width={700}
                footer={[
                  <Button key="back" onClick={handleAppScriptCancel}>
                    Hủy
                  </Button>,
                  <Button
                    key="submit"
                    type="primary"
                    loading={submittingAppScript}
                    onClick={submitAppScriptLink}
                  >
                    Thêm
                  </Button>,
                ]}
              >
                <Form form={form} layout="vertical">
                  <Form.Item
                    name="scriptUrl"
                    label="URL App Script"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập URL App Script!",
                      },
                      {
                        type: "url",
                        message: "Vui lòng nhập URL hợp lệ!",
                      },
                    ]}
                  >
                    <Input
                      prefix={<LinkOutlined />}
                      placeholder="https://script.google.com/macros/s/..."
                    />
                  </Form.Item>

                  <Collapse
                    size="small"
                    bordered={false}
                    style={{ backgroundColor: "#f9f9f9", marginBottom: "16px" }}
                  >
                    <Panel header="Hướng dẫn thêm App Script" key="1">
                      <ol style={{ paddingLeft: "20px", margin: "0" }}>
                        <li>Mở Google Sheet của bạn</li>
                        <li>
                          Chọn <Text strong>Extensions</Text> &gt;{" "}
                          <Text strong>Apps Script</Text>
                        </li>
                        <li>
                          Tạo script mới và sao chép mã script từ phần mẫu bên
                          dưới
                        </li>
                        <li>
                          Nhấn <Text strong>Deploy</Text> &gt;{" "}
                          <Text strong>New deployment</Text>
                        </li>
                        <li>
                          Chọn loại triển khai <Text strong>Web app</Text>
                        </li>
                        <li>Thiết lập quyền truy cập phù hợp</li>
                        <li>
                          Nhấn <Text strong>Deploy</Text> và sao chép URL web
                          app
                        </li>
                        <li>Dán URL đó vào ô input ở trên</li>
                      </ol>
                    </Panel>
                    <Panel header="Video hướng dẫn" key="3">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <iframe
                          width="560"
                          height="315"
                          src="https://www.youtube.com/embed/B98f-TV4FHo?si=b7VMIqgI5OzL0hET"
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </Panel>

                    <Panel
                      header={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <span>Mã script mẫu</span>
                          <Button
                            type="text"
                            size="small"
                            icon={
                              copyStatus ? (
                                <CheckOutlined style={{ color: "green" }} />
                              ) : (
                                <CopyOutlined />
                              )
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              copyScript();
                            }}
                          >
                            {copyStatus ? "Đã sao chép" : "Sao chép"}
                          </Button>
                        </div>
                      }
                      key="2"
                    >
                      <div
                        style={{
                          backgroundColor: "#f3f3f3",
                          padding: "8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          maxHeight: "200px",
                          overflow: "auto",
                          fontFamily: "monospace",
                        }}
                      >
                        <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                          {EXAMPLE_SCRIPT}
                        </pre>
                      </div>
                    </Panel>
                  </Collapse>
                </Form>
              </Modal>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Binhluan;
